import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "worker-fee-group-table wrapper brg-table" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_OptionRow = _resolveComponent("OptionRow");
    const _component_v_data_table = _resolveComponent("v-data-table");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_data_table, {
            hover: "",
            "item-key": "name",
            headers: _ctx.tableHeaders,
            items: _ctx.getterWorkerDeliveryFeeGroupOptionList,
            "items-per-page": -1,
            "fixed-header": "",
            "hide-default-footer": "",
            "mobile-breakpoint": "0",
            "no-data-text": _ctx.$t(`${_ctx.lc}${_ctx.noDataText}`),
            density: "comfortable"
        }, {
            item: _withCtx(({ item }) => [
                _createVNode(_component_OptionRow, { item: item }, null, 8 /* PROPS */, ["item"])
            ]),
            bottom: _withCtx(() => _cache[0] || (_cache[0] = [])),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["headers", "items", "no-data-text"])
    ]));
}
